// removed by extract-text-webpack-plugin
module.exports = {"panel-heading":"PanelDatosActa__panel-heading___Q8Kdp","opcion-edicion":"PanelDatosActa__opcion-edicion___31Hvi","opcion-publicacion":"PanelDatosActa__opcion-publicacion___H9EcF","tabla-datos":"PanelDatosActa__tabla-datos___3CBNX","tr-header":"PanelDatosActa__tr-header___3morD","tr-datos":"PanelDatosActa__tr-datos___19kbF","td-label":"PanelDatosActa__td-label___3INdZ","td-inputTexto":"PanelDatosActa__td-inputTexto___3K1fb","td-inputNumero":"PanelDatosActa__td-inputNumero___1mpga","td-dato":"PanelDatosActa__td-dato___30Woh","opciones-acta":"PanelDatosActa__opciones-acta___4BM-N"};


//////////////////
// WEBPACK FOOTER
// ./frontEnd/inventarios/archivo-final-fcv/PanelDatosActa.css
// module id = 1041
// module chunks = 0